'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Text", {
    enumerable: true,
    get: function() {
        return Text;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useText = require("./useText");
const _renderText = require("./renderText");
const _useTextStylesstyles = require("./useTextStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const Text = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useText.useText_unstable)(props, ref);
    (0, _useTextStylesstyles.useTextStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTextStyles_unstable')(state);
    return (0, _renderText.renderText_unstable)(state);
// Work around some small mismatches in inferred types which don't matter in practice
});
Text.displayName = 'Text';
